import { match, P } from "ts-pattern";
import { mapValues } from "../lib/functional";
import {
  deserializeFunction,
  isFunction,
  isSerializedFunction,
  serializeFunction
} from "./function-serialization";
class Serializable {
}
function serializeObject(object) {
  const transferables = [];
  const serializeFunc = (func) => {
    const r = serializeFunction(func);
    transferables.push(r);
    return r;
  };
  const serializeSerializable = (obj) => {
    const [serialized, transferrables_] = obj.serialize();
    transferables.push(...transferrables_);
    return serialized;
  };
  function serialize(value) {
    return match(value).with(P.when(isFunction), serializeFunc).with(P.instanceOf(Serializable), serializeSerializable).with(P.array(), (arr) => arr.map(serialize)).with({}, (obj) => mapValues(obj, (obj2) => serialize(obj2))).otherwise(() => value);
  }
  return [serialize(object), transferables];
}
function deserializeObject(object) {
  const deserialize = (value) => match(value).with(P.when(isSerializedFunction), deserializeFunction).with(P.array(), (arr) => arr.map(deserialize)).with({}, (obj) => mapValues(obj, (obj2) => deserialize(obj2))).otherwise(() => value);
  return deserialize(object);
}
export {
  Serializable,
  deserializeObject,
  serializeObject
};
//# sourceMappingURL=object-serialization.js.map